<template>
    <div style="padding: 30px; text-align: left">
        <h1>隐私协议</h1>
        <p>
            <span
                class="zhengwen"
                style="font-family: 宋体; font-size: 15px; line-height: 24px; text-indent: 30px"
            >
                诚挚欢迎您访问本网站。
                <br />
                当您访问本网站时，我们会按照本隐私声明条款收集、使用您的个人信息并予以保护，请您完整阅读本隐私声明。
                <br />
                <br />
            </span>
            <span
                class="biaoti"
                style="
                    font-family: 宋体;
                    font-size: 15px;
                    line-height: 24px;
                    font-weight: bold;
                    text-indent: 30px;
                "
            >
                一、我们为什么需要收集、使用您的信息
            </span>
            <span
                class="zhengwen"
                style="font-family: 宋体; font-size: 15px; line-height: 24px; text-indent: 30px"
            >
                <br />
                我们收集您的信息是为了在遵守国家法律法规的规定的前提下，向您提供更优质的服务，提高用户体验，保证网络安全及改进安利网站内容，为了实现这一总体目的，我们会把您的信息用于下列用途：
                <br />
                1.为了向您提供我们经营的安永（中国）保健品有限公司网站上的各项服务及实现相关功能，并维护、改进这些服务和功能。
                <br />
                2.为了改进安永（中国）保健品有限公司的服务质量，便于收取您对安永（中国）保健品有限公司及其服务的各种意见和建议，及时有针对性地向您提供反馈或解决方案。
                <br />
                3.为了系统安全并协助您解决在使用安利网站服务时可能遇到的相关问题，我们会收集您的个人信息。
                <br />
                4.我们因业务分析、市场调研需要，也会使用到您的个人信息。
                <br />
                5.我们可能会将您的个人信息跨境转移用于关联公司的调研和分析，或者共享给第三方服务提供者、商业伙伴用于联合向您提供服务、调研和分析。在此情况下，安永（中国）保健品有限公司要求相关公司也必须遵守本声明的规定。
                <br />
            </span>
            <span
                class="biaoti"
                style="
                    font-family: 宋体;
                    font-size: 15px;
                    line-height: 24px;
                    font-weight: bold;
                    text-indent: 30px;
                "
            >
                <br />
                二、我们收集、使用您的个人信息的方式
            </span>
            <span
                class="zhengwen"
                style="font-family: 宋体; font-size: 15px; line-height: 24px; text-indent: 30px"
            >
                <br />
                1.当您访问安永（中国）保健品有限公司网站，通过互联网获取安永（中国）保健品有限公司的任意服务，或使用安永（中国）保健品有限公司网站的某项功能时，您会主动向我们提供一些个人信息，我们也将会收集您的一些个人信息。
                <br />
                2.除非另行书面说明，本声明不适用于安永（中国）保健品有限公司通过其他方式，如通过非网络的离线方式收集的信息。
                <br />
                <br />
            </span>
            <span
                class="biaoti"
                style="
                    font-family: 宋体;
                    font-size: 15px;
                    line-height: 24px;
                    font-weight: bold;
                    text-indent: 30px;
                "
            >
                三、我们收集和使用哪些个人信息
            </span>
            <span
                class="zhengwen"
                style="font-family: 宋体; font-size: 15px; line-height: 24px; text-indent: 30px"
            >
                <br />
                1.为了向您提供更个性化、更便捷的服务，您可能要根据网站要求主动向我们提供相关信息，例如您的姓名、地址、电话号码、电子邮件地址。
                <br />
                2.出于保证系统安全，解决您使用网站服务时可能遇到的相关问题等原因，我们会保存您登录系统的时间、访问的菜单或链接、IP地址、操作日志等信息，并严格按照法律法规的规定对这些信息进行妥善保管。
                <br />
                如果您拒绝提供相关的信息可能导致您的要求或者需要的服务无法满足。
                <br />
                <br />
            </span>
            <span
                class="biaoti"
                style="
                    font-family: 宋体;
                    font-size: 15px;
                    line-height: 24px;
                    font-weight: bold;
                    text-indent: 30px;
                "
            >
                四、与第三方共享信息
            </span>
            <span
                class="zhengwen"
                style="font-family: 宋体; font-size: 15px; line-height: 24px; text-indent: 30px"
            >
                <br />
                我们在以下情况下可能与第三方共享您的信息：
                <br />
                （1）为了保障和捍卫我们的权利或财产。
                <br />
                （2）根据法律法规的规定及国家机关的要求。
                <br />
                <br />
            </span>
            <span
                class="biaoti"
                style="
                    font-family: 宋体;
                    font-size: 15px;
                    line-height: 24px;
                    font-weight: bold;
                    text-indent: 30px;
                "
            >
                五、Cookie及其他技术
            </span>
            <span
                class="zhengwen"
                style="font-family: 宋体; font-size: 15px; line-height: 24px; text-indent: 30px"
            >
                <br />
                我们可能会使用安永（中国）保健品有限公司公司官方网站及其相关网站上的Cookies应用程序。Cookies应用程序是网站服务器为保存记录而向个人用户的电脑所传递的数据。我们使用Cookies及其他技术是为了使我们的系统能够识别您的设备，从而为您持续访问和使用我们的网站提供便利。
                <br />
                多数浏览器上工具条中的帮助部分会告诉您怎样防止您的浏览器接受新的Cookies，怎样让您的浏览器在您收到一条新Cookies时通知您或者怎样关闭Cookies。此外，您可以通过改变浏览器附加程序的设置，来关闭或删除浏览器附加程序使用的类似数据。
                <br />
                <br />
            </span>
            <span
                class="biaoti"
                style="
                    font-family: 宋体;
                    font-size: 15px;
                    line-height: 24px;
                    font-weight: bold;
                    text-indent: 30px;
                "
            >
                六、IP地址
            </span>
            <span
                class="zhengwen"
                style="font-family: 宋体; font-size: 15px; line-height: 24px; text-indent: 30px"
            >
                <br />
                您的IP地址是指当您使用网络服务器时，自动分配到您正在使用的电脑的号码。当您访问安利网站时，该号码及访问时间和访问网页将会被自动识别并记录在我们的服务器日志文件当中。收集IP地址是互联网的惯例并且许多网站会自动进行收集。
                <br />
                <br />
            </span>
            <span
                class="biaoti"
                style="
                    font-family: 宋体;
                    font-size: 15px;
                    line-height: 24px;
                    font-weight: bold;
                    text-indent: 30px;
                "
            >
                七、第三方网站链接
            </span>
            <span
                class="zhengwen"
                style="font-family: 宋体; font-size: 15px; line-height: 24px; text-indent: 30px"
            >
                <br />
                安永（中国）保健品有限公司网站将会提供第三方网站的链接。我们不对其他网站的隐私政策或内容承担责任。
                <br />
                <br />
            </span>
            <span
                class="biaoti"
                style="
                    font-family: 宋体;
                    font-size: 15px;
                    line-height: 24px;
                    font-weight: bold;
                    text-indent: 30px;
                "
            >
                八、未成年人保护
            </span>
            <span
                class="zhengwen"
                style="font-family: 宋体; font-size: 15px; line-height: 24px; text-indent: 30px"
            >
                <br />
                我们仅向年满18周岁的人士提供服务。如果您为未成年人，请不要向我们提供个人信息，我们也不建议您使用安永（中国）保健品有限公司网站提供的服务。
                <br />
                <br />
            </span>
            <span
                class="biaoti"
                style="
                    font-family: 宋体;
                    font-size: 15px;
                    line-height: 24px;
                    font-weight: bold;
                    text-indent: 30px;
                "
            >
                九、个人信息的安全与保护
            </span>
            <span
                class="zhengwen"
                style="font-family: 宋体; font-size: 15px; line-height: 24px; text-indent: 30px"
            >
                <br />
                我们会对收集的个人信息严格保密。我们亦会采取适当的技术措施和其他必要措施，确保信息安全，以防止该等个人信息的泄漏和丢失。如您不同意您的个人信息按本隐私声明的规定进行收集和使用，请勿使用我们的网站或向我们提供您的个人信息。
                <br />
            </span>
            <span
                class="biaoti"
                style="
                    font-family: 宋体;
                    font-size: 15px;
                    line-height: 24px;
                    font-weight: bold;
                    text-indent: 30px;
                "
            >
                <br />
                十、联系方式
            </span>
            <span
                class="zhengwen"
                style="font-family: 宋体; font-size: 15px; line-height: 24px; text-indent: 30px"
            >
                <br />
                如对本隐私声明条款有任何投诉、建议，您可以通过以下方式联系我们。
                <br />
                &nbsp;安永（中国）保健品有限公司
                <br />
                &nbsp;邮箱：
            </span>
            <b style="line-height: 1.42857">
                <span style="font-family: 宋体; font-size: 10.5pt">
                    &nbsp;anyongjiankang01@outlook.com &nbsp;
                </span>
            </b>
            <br />
        </p>
    </div>
</template>
<script>
export default {
    name: 'Fashion',
    data() {
        return {};
    }
};
</script>

<style scoped>
* {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
}
.img {
    height: 500px;
    width: 100%;
}
</style>
